import { useEffect, useMemo, useState } from "react";
import MalasiaFlag from "../../../components/icons/flags/MalasiaFlag"
import MarketItem from "./MarketItem";
import { GetBrandPreferences } from "../../../API/endpoints/Brands";
import Spinner from "./Spinner";

interface Props {
    brandId: string
}
const MatketPreferences = (props: Props) => {
    const { brandId } = props;

    const [markets, setMarkets] = useState<any[]>([])
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        setLoading(true)
        GetBrandPreferences(brandId).then((res: any) => {
            setMarkets(res?.data?.market_preference || []);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.error("unablde to fetch brand preferences");

        })
    }, [brandId])

    const marketsList = useMemo(() => {
        return markets.map((item) => {
            return <MarketItem
                key={item.id}
                data={item}
            />
        })
    }, [markets])

    return (
        <div className="grid grid-cols-4 gap-[16px] overflow-auto h-[calc(100vh-246px)]">
            {loading ? (
                <div className="col-span-4">
                    <Spinner />
                </div>

            ) : (
                marketsList
            )}
        </div>
    )
}

export default MatketPreferences